import { useContext, useEffect, useState } from 'react'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { InformationContext } from 'src/consumer/context/InformationContext'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { buildBreadcrumbs } from 'src/consumer/helpers/seoHelpers'
import { getFeatureList } from 'src/consumer/services/featureServices'
import { GenericInformationModal } from '../GenericInformationModal'
import { PublicListingComponentVarOne } from '../ListingPageComponentsAndHelpers/ListingPageComponents'
import { getListItemsFromTechniqueList } from '../ListingPageComponentsAndHelpers/ListingPageHelpers'
import { LoadingSpinner } from '../Loaders'
import PublicAppHeader from '../PublicAppHeader'
import { useNavigate } from 'react-router-dom'

export default function TechniqueListingPage() {
  const navigate = useNavigate()
  const [pageLoading, setPageLoading] = useState(false)
  const [techniqueList, setTechniqueList] = useState()

  const [pageNumber, setPageNumber] = useState(1)
  const [hasNextPage, setHasNextPage] = useState(true)

  const { informationModalData, setInformationModalData } = useContext(InformationContext)

  async function pageSetup() {
    setPageLoading(true)
    const resp = await getFeatureList('technique')
    if (resp?.status === 200) {
      setTechniqueList(resp?.data)
    }
    setPageLoading(false)
  }

  async function getNextTechniquePage() {
    const nextPageNumber = pageNumber + 1

    const resp = await getFeatureList('technique', nextPageNumber)

    if (resp?.status === 200) {
      if (resp?.data && resp?.data?.length > 0) {
        setPageNumber(nextPageNumber)
        setTechniqueList((prev) => [...prev, ...resp?.data])
      } else {
        // If there's no more data to load, set hasNextPage to false
        setHasNextPage(false)
      }
    } else {
      setHasNextPage(false)
    }
  }

  const [sentryRef] = useInfiniteScroll({
    hasNextPage,
    onLoadMore: getNextTechniquePage,
    rootMargin: '0px 0px 20px 0px',
  })

  useEffect(() => {
    pageSetup()
  }, [])

  return (
    <>
      <SEOComponent
        title="Mental wellness techniques — guided practices | AUMHUM"
        description="Short, practical techniques you can try any time — breathing, grounding, thought-reframing, and more — curated by AUMHUM's clinical team."
        image={APP_CONSTANTS.APP_LOGO_LINK}
        pathname="/technique"
        keywordsArr={[
          'mental wellness techniques',
          'mindfulness',
          'breathing exercises',
          'grounding',
          'self-regulation',
        ]}
        jsonLd={buildBreadcrumbs([
          { name: 'Home', path: '/' },
          { name: 'Techniques', path: '/technique' },
        ])}
      />
      {pageLoading ? (
        <LoadingSpinner bgColor="#F5F5F599" dark />
      ) : (
        <>
          <PublicAppHeader config={{ showLinks: true }} />
          <PublicListingComponentVarOne
            heading="Explore Technique"
            description="Explore Technique"
            actionText="Start"
            listItemsArray={getListItemsFromTechniqueList(techniqueList)}
            sentryRef={sentryRef}
            hasNextPage={hasNextPage}
          />
          {informationModalData?.showModal && <GenericInformationModal />}
        </>
      )}
    </>
  )
}
